// @ts-strict-ignore
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import {
  ActivatedRoute,
  GuardsCheckEnd,
  GuardsCheckStart,
  NavigationEnd,
  NavigationStart,
  ResolveEnd,
  ResolveStart,
  Scroll
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { serializeRoute } from 'src/app/core/services/activated-route/activated-route.utils';
import { RouterEvent } from 'src/app/core/services/router-events/router-event.type';
import { RouterEventsService } from 'src/app/core/services/router-events/router-events.service';
import { HEADER_SCROLL_ANCHOR_ID } from 'src/app/utils/global-constants';

import {
  routerGuardsCheckEndAction,
  routerGuardsCheckStartAction,
  routerNavigationEndAction,
  routerNavigationStartAction,
  routerResolveEndAction,
  routerResolveStartAction,
  routerScrollAction
} from './router.actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getRouterEventActions = (route: ActivatedRoute): Record<string, (event: RouterEvent) => any> => ({
  navigationStart$: (event: NavigationStart) =>
    routerNavigationStartAction({
      event
    }),
  guardsCheckStart$: (event: GuardsCheckStart) =>
    routerGuardsCheckStartAction({
      routeState: serializeRoute(event.state.root)
    }),
  guardsCheckEnd$: (event: GuardsCheckEnd) =>
    routerGuardsCheckEndAction({
      routeState: serializeRoute(event.state.root)
    }),
  resolveStart$: (event: ResolveStart) =>
    routerResolveStartAction({
      routeState: serializeRoute(event.state.root)
    }),
  resolveEnd$: (event: ResolveEnd) =>
    routerResolveEndAction({
      routeState: serializeRoute(event.state.root)
    }),
  navigationEnd$: (event: NavigationEnd) =>
    routerNavigationEndAction({
      routeState: serializeRoute(route.snapshot),
      event
    }),
  scroll$: (event: Scroll) =>
    routerScrollAction({
      routeState: serializeRoute(route.snapshot),
      event: new Scroll(event.routerEvent, event.position, event.anchor || HEADER_SCROLL_ANCHOR_ID)
    })
});

export function connectRouterStore(
  routerEvents: RouterEventsService,
  route: ActivatedRoute,
  // TODO: Fix with MBCC-2545
  // Store<any> should not be necessary (in theory). I have no idea what the correct type should be.
  // eslint-disable-next-line @ngrx/no-typed-global-store, @typescript-eslint/no-explicit-any
  store: Store<any>
): () => void {
  return () => {
    for (const [event$, mapAction] of Object.entries(getRouterEventActions(route))) {
      (routerEvents[event$] as Observable<RouterEvent>).pipe(map(mapAction)).subscribe(store);
    }
  };
}

@NgModule({
  providers: [
    provideAppInitializer(() => {
      const initializerFn = connectRouterStore(inject(RouterEventsService), inject(ActivatedRoute), inject(Store));
      initializerFn();
    })
  ]
})
export class RouterStoreModule {}
